<template>
  <div>
    <v-row justify="space-between">
      <v-col cols="7" sm="6" md="5" class="ml-3" >
        <transition name="slide-y-transition">
          <v-autocomplete
            clearable
            :items="renderedClients"
            v-model="clientId"
            item-text="name"
            item-value="id"
            label="Pick a client name"
            prepend-icon="fas fa-user"
            :menu-props="{transition: 'slide-x-transition'}"
            :class="isInternalUser() ? 'd-flex': 'd-none'"
            @input="updateDataTable"
          >
          </v-autocomplete>
        </transition>
      </v-col>

      <v-col
        cols="4"
        sm="3"
        md="2"
        class="text-center"
        v-if=" (renderedClients.filter(client => client.id === clientId).length > 0 && renderedClients.filter(client => client.id === clientId)[0].api_access_level) ||
               (!isInternalUser() && renderedClients.filter(client => client.id === userClient).length > 0 && renderedClients.filter(client => client.id === userClient)[0].api_access_level)"
      >
        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on }">
            <v-btn @click="newApiKey" class="mx-2" fab dark color="blue lighten-1" v-on="on">
              <v-icon dark>add</v-icon>
            </v-btn>
          </template>
          <span>Create a new {{tableInfo.name}}</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="renderedApiKeys"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.types="{ item }">
        {{getDescriptions(item.types).join(", ")}}
      </template>
      <template v-slot:item.enabled="{ item }">
        <v-simple-checkbox v-model="item.enabled" disabled></v-simple-checkbox>
      </template>
      <template v-slot:item.production="{ item }">
        <v-simple-checkbox v-model="item.production" disabled></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="selectRow(item)">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn icon @click="openDeleteDialog(item)">
          <v-icon>delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
      v-model="apiKeyDialog"
      max-width="600px"
    >
        <v-card>
        <v-card-title>
          <h3>{{editedIndex > -1 ? 'Edit ' + tableInfo.name : 'New '+tableInfo.name }}</h3>
        </v-card-title>

        <v-card-text v-if="tableInfo.name=='Api Key'">
          <v-text-field
            v-model="keyItem.name"
            label="Name"
            prepend-icon="fas fa-key"
          ></v-text-field>
          <v-row justify="space-between">
            <v-col cols="6">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="keyItem.expires"
                    label="Expires in..."
                    prepend-icon="event"
                    readonly
                    @click.native="menu = true"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="keyItem.expires" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(keyItem.expires)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col>
              <v-switch
                v-model="keyItem.production"
                class="mr-4"
                label="In production"
              ></v-switch>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-text v-if="tableInfo.name=='Webhook'">
          <v-select
            v-model="keyItem.types"
            :items="renderedTypeList"
            item-value="name"
            item-text="description"
            label="Type"
            chips
            multiple
          ></v-select>
          <v-row justify="space-between">

            <v-text-field
              v-model="keyItem.url"
              label="Url"
              prepend-icon="fas fa-link"
              hint="For example, https://so.com"
            ></v-text-field>

            <v-col>
              <v-switch
                v-model="keyItem.enabled"
                class="mr-4"
                label="Enabled"
              ></v-switch>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            text
            @click="closeApiKeysDialog"
            color="blue-grey lighten-2"
          >Cancel
          </v-btn>
          <v-btn
            text
            @click="saveChanges"
            color="blue darken-1"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="isKeyDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <h3>Your {{tableInfo.name}} is:</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field
            class="mt-3"
            v-model="clientKey"
            label="click to copy"
            readonly
            outlined
            @click="copyElement"
            >
          </v-text-field>
          <p style="text-align: center;">Please save it somewhere. You won't be able to access it later</p>
          <v-btn text color="primary" @click="closeShowKey">Close Window</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <h3>Delete this {{tableInfo.name}} ?</h3>
        </v-card-title>
        <v-card-text>
          <v-btn text color="primary" @click="deleteItem">Confirm</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    name: "ApiKeyManager",
    props : {
      headers_props: Array,
      tableInfo: Object,
      keyItem_props: Object
    },
    data() {
      return {
        clientId: 0,
        apiKeyDialog: false,
        editedIndex: -1,

        clientKey: null,
        isKeyDialog: false,
        deleteDialog: false,
        menu: false,
        reload: false,
        loading: false,
        headers: this.headers_props,
        keyItem: this.keyItem_props,
      }
    },
    methods: {
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      },
      updateDataTable() {
        this.reload = !this.reload;
      },
      newApiKey() {
        this.editedIndex = -1;
        this.keyItem = Object.assign({}, this.default);
        this.keyItem.url = "https://";
        this.apiKeyDialog = true;
      },
      selectRow(item) {
        this.editedIndex = item.id;
        this.keyItem = Object.assign({}, item);
        this.apiKeyDialog = true;
      },
      openShowKey( key){
        this.isKeyDialog = true;
        this.clientKey = key;
      },
      closeShowKey(){
        this.isKeyDialog = false;
        this.clientKey = null;
      },
      openDeleteDialog(item){
        this.deleteDialog = true;
        this.editedIndex = item.id;
      },
      copyElement(){
        const el = document.createElement('textarea');
        el.value = this.clientKey;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.$store.commit('displaySnackbar', this.tableInfo.name +' has been successfully copied');
      },
      saveChanges() {
        if (this.editedIndex > -1) {
          this.editItem();
        } else {
          this.createItem();
        }
      },
      createItem(){
        let body = this.keyItem;
        const clientId = this.isInternalUser() ? this.clientId : this.$store.getters['auth/client_id'];

        if (this.tableInfo.name=='Api Key'){
          if (body.name === null) {
            this.$store.commit('displaySnackbar', 'Please select a name for the Api');
            return false;
          }
        } else {
          body.client_id = clientId;
        }

        axios.post(process.env.API_URL + this.tableInfo.apiUrl(clientId), body)
          .then((response) => {
            this.$store.commit('displaySnackbar', 'Create successful');
            this.updateDataTable();
            this.openShowKey(response.data.key);
            this.closeApiKeysDialog();
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      },
      editItem(){
        let body = this.keyItem;
        axios.put(process.env.API_URL + '/webhooks/' + this.editedIndex, body)
          .then(() => {
            this.$store.commit('displaySnackbar', 'Edited successful');
            this.updateDataTable();
            this.closeApiKeysDialog();
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      },
      deleteItem(){
        axios.delete(process.env.API_URL + '/webhooks/' + this.editedIndex)
          .then(() => {
            this.$store.commit('displaySnackbar', 'Delete successful');
            this.updateDataTable();
            this.deleteDialog = false;
            this.editedIndex = -1;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      },
      closeApiKeysDialog(){
        this.apiKeyDialog = false;
        this.editedIndex = -1;
      },
      getDescriptions(names) {
        return this.renderedTypeList.filter((type) => {
          return names.includes(type.name);
        }).map((type) => {
          return type.description;
        })
      }
    },
    computed: {
      renderedApiKeys() {
        if (this.ApiKeys === null || this.ApiKeys === undefined){
          return [];
        } else {
          return this.ApiKeys;
        }
      },
      renderedClients() {
        if (this.clients === null || this.clients === undefined){
          return [];
        } else {
          return this.clients;
        }
      },
      renderedTypeList() {
        if (this.typeList === null || this.typeList === undefined){
          return [];
        } else {
          return this.typeList;
        }
      }
    },
    asyncComputed: {
      userClient() {
        return this.$store.getters['auth/client_id'];
      },
      async ApiKeys() {
        if (this.reload || !this.reload) {
          this.loading = true;
          const clientId = this.isInternalUser() ? this.clientId : this.$store.getters['auth/client_id'];
          return await axios.get(process.env.API_URL + this.tableInfo.apiUrl(clientId) )
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            });
        }
      },
      async clients() {
        if (this.$store.getters['auth/client_id'] || !this.$store.getters['auth/client_id']) {
          const withInactive = (this.tableInfo.name=='Api Key') ? "?inactive=true": "";
          return await axios.get(process.env.API_URL + '/clients' + withInactive)
            .then((response) => {
              if (response.status === 200) {
                return Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
              } else {
                return [];
              }
            })
            .catch((error) => {
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            });
        }
      },
      async typeList() {
        if (this.$store.getters['auth/client_id'] || !this.$store.getters['auth/client_id']) {
          return await axios.get(process.env.API_URL + '/webhooks/types')
            .then((response) => {
              if (response.status === 200) {
                return Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
              } else {
                return [];
              }
            })
            .catch((error) => {
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            });
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/ManageKeys/ApiKeyManager.vue